define('TescoMobile_Checkout/js/form/previous-address',['Magento_Ui/js/form/components/fieldset', 'uiRegistry', 'TescoMobile_Checkout/js/form/billing-address'], function (Component, uiRegistry) {
  'use strict';

  return Component.extend({
    defaults: {
      visible: false,
      imports: {
        movedToAddressLessThanConfigThreshold: "${ $.parentName }.billing_address:movedToAddressLessThanConfigThresholdValue",
        isVisibleCheck: "${ $.parentName }.billing_address:displayPreviousAddress",
        validateOnInput: "${ $.provider }:${ $.customScope }.tm_start_date"
      }
    },
    isOutsideUkChecked: false,
    tracks: {
      visible: true,
      addressOutsideUk: true,
      isVisibleCheck: true,
      movedToAddressLessThanConfigThreshold: true,
      isChecked: false
    },
    validateOnInput: function () {
      var monthField = uiRegistry.get(this.name + '.tm_start_date.0'),
        yearField = uiRegistry.get(this.name + '.tm_start_date.1');
      if (typeof monthField !== 'undefined' && typeof yearField !== 'undefined' && monthField.value() && yearField.value()) {
        monthField.validate();
        yearField.validate();
      }
    },
    addressOutsideUk: function (isChecked) {
      this.isChecked = isChecked;
      if (!isChecked && this.movedToAddressLessThanConfigThreshold === true) {
        this.visible(true);
        uiRegistry.get('checkoutProvider', function (component) {
          component.set('previous_address_visible', true);
        });
        this.isOutsideUkChecked = false;
        this.setPostcodeAndBuildingIdFieldsAsRequired();
      } else {
        this.isOutsideUkChecked = true;
        uiRegistry.get('checkoutProvider', function (component) {
          component.set('previous_address_visible', false);
        });
        this.visible(false);
        this.disablePostcodeAndBuildingIdFields();
      }
    },
    isVisibleCheck: function (displayPreviousAddress) {
      this.addressOutsideUk(this.isChecked);
      if (!this.isOutsideUkChecked && displayPreviousAddress === true) {
        uiRegistry.get('checkoutProvider', function (component) {
          component.set('previous_address_visible', true);
        });
        this.visible(true);
        this.setPostcodeAndBuildingIdFieldsAsRequired();
      } else {
        uiRegistry.get('checkoutProvider', function (component) {
          component.set('previous_address_visible', false);
        });
        this.visible(false);
        this.disablePostcodeAndBuildingIdFields();
      }
    },
    setPostcodeAndBuildingIdFieldsAsRequired() {
      const postcode = uiRegistry.get(this.name + '.postcode');
      const buildingId = uiRegistry.get(this.name + '.tm_building_id');
      if (typeof postcode !== 'undefined' && typeof buildingId !== 'undefined') {
        postcode.disabled(false).required(true).validation['required-entry'] = true;
        buildingId.disabled(false).required(true).validation['required-entry'] = true;
      }
    },
    disablePostcodeAndBuildingIdFields() {
      const postcode = uiRegistry.get(this.name + '.postcode');
      const buildingId = uiRegistry.get(this.name + '.tm_building_id');
      if (typeof postcode !== 'undefined' && typeof buildingId !== 'undefined') {
        postcode.disabled(true).required(false).validation['required-entry'] = false;
        buildingId.disabled(true).required(false).validation['required-entry'] = false;
      }
    }
  });
});

